import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import {
  getEditorColor,
  getEditorColorForIcon,
  renderColor,
  renderStatsBg,
} from '../../util/ColorUtil';
import {
  getEditorColors,
  getHoverColorLocation,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import CtaBarButton from '../base/cta-bar-button';
import FacilityModal from '../modal/FacilityModal';
import { cleanHTML } from '../utils/htmlUtils';
import { getMetricSystemForLanguage } from '../../util/LocationsUtil';
import { useRouter } from 'next/router';
import CountUpComponent from './CountUpComponent';

const TemplateStatsRight = (props) => {
  const router = useRouter();
  const { asPath, locale } = router;

  const dataSet = {
    ...props?.facilityData,
    ...props?.metroData,
    ...props?.locationData,
    ...props?.regionData,
    ...props?.global,
  };
  const isBlockWithCta = props?.children?.field_cta_bar_button_selection[0]
    ?.cta_bar_button?.field_cta_bar_button_text_1[0]?.value
    ? true
    : false;
  const statsSize =
    props?.children.field_stats?.stats_coloured_fields_type?.length;
  const iconColor = getEditorColor(
    isItUndefined(props?.children?.field_long_formatted)
  );
  const ediatbleIcon = getEditorColor(
    isItUndefined(props?.children?.field_long_formatted)
  );
  const isDescriptionAndNotHeadline =
    !props?.children?.field_long_formatted[0]?.value &&
    props?.children?.field_description[0]?.value
      ? true
      : false;
  const emphasizedTextColor = getEditorColors(
    isItUndefined(props?.children?.field_long_formatted),
    isItUndefined(props?.children?.field_description)
  ).filter((x) => x)[0];
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  const metricSystem = getMetricSystemForLanguage(props.lang);
  const isH2ClassStyled =
    props?.children?.field_headline_variant?.[0]?.value === 'h2_class_styled';

  // const [isVisible, setIsVisible] = useState(false);
  // const blockRef = useRef();

  // useEffect(() => {
  //   const observer = new IntersectionObserver(([entry]) => {
  //     if (entry.isIntersecting) {
  //       setIsVisible(true);
  //       observer.disconnect(); // Stop observing after triggering
  //     }
  //   });
  //
  //   if (blockRef.current) observer.observe(blockRef.current);
  //
  //   return () => observer.disconnect();
  // }, []);

  const transformValueFt2ToM2 = (value, dataSet) => {
    if (metricSystem == 'Metric') {
      if (value?.includes('field_total_facility_ft2')) {
        return value.replace(
          '[[field_total_facility_ft2]]',
          '[[field_total_facility_m2]]'
        );
      }
    }
    return value;
  };

  const transformValueM2ToFt2 = (value, dataSet) => {
    if (metricSystem == 'Metric') {
      if (value?.includes('field_total_facility_m2')) {
        return value.replace(
          '[[field_total_facility_m2]]',
          '[[field_total_facility_ft2]]'
        );
      }
    }
    return value;
  };

  const renderStats = (data) => {
    if (!data || data.length === 0) {
      return;
    }

    const filteredData = data.filter((item) => {
      const descriptionValue = item?.field_description_formatted[0]?.value;
      const targetString = 'field_utility_power_capacity';

      // Check if the description includes the target string
      return descriptionValue && !descriptionValue.includes(targetString);
    });

    return filteredData.map((item, index) => {
      const descriptionValue = transformValueFt2ToM2(
        item?.field_description_formatted[0]?.value,
        dataSet
      );
      const valueValue = transformValueM2ToFt2(
        item?.field_value_formatted[0]?.value,
        dataSet
      );

      const processedStaticValue = cleanHTML(
        modifyLinks(
          abbreviateStringNumber(
            getObjectValueByMachineName(descriptionValue, dataSet, '', props?.contentType),
            props?.contentType
          ),
          locale
        )
      );
      const isShortStaticValue =
        (processedStaticValue || '').replace(/<[^>]*>/g, '').trim().length < 12;
      const isShortAnimatedValue =
        ((item?.field_end_value?.[0]?.value || '') +
          (item?.field_stats_suffix?.[0]?.value || '')).length < 12;

      return (
        <div className="stats-list" key={`stats-list-${item?.field_description_formatted?.[0]?.value || 'stat'}`}>
          {item?.field_enable_animation?.[0]?.value === '1' ? (
            <div className={`stats-value${isShortAnimatedValue ? ' nowrap' : ''}`}>
              {/*{isVisible && (*/}
              <CountUpComponent
                startValue={item?.field_start_value[0]?.value}
                endValue={item?.field_end_value[0]?.value}
                color={item?.field_stats_color?.[0]?.color}
                suffix={item?.field_stats_suffix[0]?.value}
                decimals={item?.field_decimal_places[0]?.value}
                duration={item?.field_animation_duration[0]?.value}
              />
              {/*)}*/}
            </div>
          ) : (
            <div
              className={`stats-value${isShortStaticValue ? ' nowrap' : ''}`}
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  modifyLinks(
                    abbreviateStringNumber(
                      getObjectValueByMachineName(
                        descriptionValue,
                        dataSet,
                        '',
                        props?.contentType
                      ),
                      props?.contentType
                    ),
                    locale
                  )
                ),
              }}
            />
          )}
          <div
            className={'stats-description'}
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                abbreviateStringNumber(
                  getObjectValueByMachineName(
                    valueValue,
                    dataSet,
                    '',
                    props?.contentType
                  ),
                  props?.contentType
                ),
                locale
              ),
            }}
          />
        </div>
      );
    });
  };

  const abbreviateStringNumber = (inputString, blockType) => {
    if (!inputString) return;

    const numberMatch = inputString.match(/\d+/);

    if (blockType == 'facility') {
      if (numberMatch) {
        if (numberMatch[0]?.startsWith('0')) {
          return inputString;
        }
        const number = parseInt(numberMatch[0], 10);
        const abbreviatedNumber = abbreviateNumber(number, 1000);

        const outputString = inputString.replace(
          numberMatch[0],
          abbreviatedNumber
        );

        return outputString;
      }
    }

    return inputString;
  };

  const abbreviateNumber = (number, divisor) => {
    const abbreviations = ['', 'k', 'M', 'B', 't'];
    let abbreviationIndex = 0;
    while (number >= divisor && abbreviationIndex < abbreviations.length - 1) {
      number /= divisor;
      abbreviationIndex++;
    }
    const abbreviatedNumber = (Math.round(number * 1000) / 1000)
      .toFixed(1)
      .replace(/\.0$/, '');

    return abbreviatedNumber + abbreviations[abbreviationIndex];
  };

  const renderBullets = (data) => {
    if (!data || data.length == 0) {
      return;
    }

    return data.map((item, key) => {
      return (
        <div className="bullet-items" key={`bullet-item-${item?.value || key}`}>
          {props.children?.field_font_awesome_icon[0]?.icon_name ? (
            <FontAwesomeIcon
              className={iconColor ? iconColor : ''}
              path="fill"
              color={iconColor ? iconColor : ''}
              fill={iconColor ? iconColor : ''}
              icon={[
                props?.children?.field_font_awesome_icon[0]?.style,
                props?.children?.field_font_awesome_icon[0]?.icon_name,
              ]}
              style={{ fill: iconColor ? iconColor : '' }}
            />
          ) : (
            <img
              style={{ filter: getHoverColorLocation(ediatbleIcon) }}
              className="checkbox"
              alt="checkbox"
              src="/images/check-box.svg"
            />
          )}
          <span className="bullet-item">
            {getObjectValueByMachineName(item?.value, dataSet)}
          </span>
        </div>
      );
    });
  };

  const stats = props?.children?.field_stats?.stats_coloured_fields_type;
  const hasStats = stats?.length > 0;
  const showOverlayImage = !['metro', 'region', 'location'].includes(
    props?.contentType
  );
  return (
    <>
      <section
        // ref={blockRef}
        className={`template-stats ${renderStatsBg(props?.children?.field_text_color[0]?.value, props?.regionColor)} ${statsSize == 1 ? 'single-stat' : ''} ${isBlockWithCta ? 'with-cta' : ''} ${isDescriptionAndNotHeadline ? 'without-headline' : ''} ${isH2ClassStyled ? 'headline-h2-class-styled' : ''} ${!showOverlayImage ? 'location-page' : ''}`}
      >
        <div className="inner-container">
          <div className={'template-stats-container'}>
            <div className={`template-title-div`}>
              {props?.children?.field_long_formatted[0]?.value ? (
                <h2
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML(
                      modifyLinks(
                        props?.children?.field_long_formatted[0]?.value,
                        locale
                      )
                    ).replace(/<\/?p>/gi, ''),
                  }}
                  className={`template-stats-title ${isH2ClassStyled ? 'h2-class-styled' : ''} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                ></h2>
              ) : (
                <></>
              )}
              {props?.children?.field_description[0]?.value ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML(
                      modifyLinks(
                        props?.children?.field_description[0]?.value,
                        locale
                      )
                    ),
                  }}
                  className={`template-stats-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                />
              ) : (
                <></>
              )}
              {props?.children?.field_cta_bar_button_selection[0]
                ?.cta_bar_button?.field_cta_bar_button_text_1[0]?.value ? (
                <CtaBarButton
                  setMarketoTrigger={setMarketoTrigger}
                  pathname={true}
                  blockTypeClass={'stats-right'}
                  data={
                    props?.children?.field_cta_bar_button_selection[0]
                      ?.cta_bar_button
                  }
                  bgColor={renderStatsBg(
                    props?.children?.field_text_color[0]?.value,
                    props?.regionColor
                  )}
                />
              ) : (
                <></>
              )}
              {props?.children?.field_bullet_item_text?.length > 0 ? (
                <div className="bullets">
                  {renderBullets(props?.children?.field_bullet_item_text)}
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className={`stats ${statsSize === 1 ? 'single-stat' : ''}`}>
              {statsSize >= 2 && renderStats(stats)}

              {statsSize < 2 && hasStats && (
                <div className={`overlay${!showOverlayImage ? ' no-overlay-image' : ''}`}>
                  {renderStats(stats)}

                  {showOverlayImage && (
                    <img
                      className="overlay"
                      src="/images/why-super-overlay.png"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {marketoTrigger && (
        <FacilityModal
          lang={props?.lang}
          global={props?.global}
          setTrigger={setMarketoTrigger}
          trigger={marketoTrigger}
        >
          {
            props?.children?.field_cta_bar_button_selection[0]?.cta_bar_button
              ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
          }
        </FacilityModal>
      )}
    </>
  );
};

export default TemplateStatsRight;
